<template>
    <DefaultTemplate :pageWhite="false">
		<InvestCompanyDetail />
	</DefaultTemplate>
</template>
<script>
import InvestCompanyDetail from '@/components/InvestCompanyDetail'
import  DefaultTemplate from '../template/DefaultTemplate'
export default {
    name:'InvestCompanyDetailView',
    components:{
        InvestCompanyDetail,
        DefaultTemplate
    }
};
</script>
<style scoped>
	
</style>